var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerPharmacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#AA0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160-160v-33.85L241.54-440 160-686.15V-720h483.38l53.39-147.69 41.69 15.54L690.92-720H800v33.85L718.46-440 800-193.85V-160H160Zm300-147.69h40V-420h112.31v-40H500v-112.31h-40V-460H347.69v40H460v112.31ZM204-200h552l-80-240 80-240H204l80 240-80 240Zm276-240Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPharmacyIcon);
export default __webpack_public_path__ + "static/media/marker-pharmacy-icon.c596ba4bb75d2208e6c21ddfdfc7ca21.svg";
export { ForwardRef as ReactComponent };